import {gql} from 'apollo-boost';

export const ME = gql`
  query {
    User {
      get {
        email
        firstName
        lastName
        verifyCode
        verified
        company
        phone
        error
        id
        photo
        premium_credit_subscription_cancel_at
        premium_credit_subscription_status
        premium_credits_pricing_package
        premium_credits_pricing_package_interval
        left_premium_credits
      }
    }
  }
`;

export const GET_AUTOMATIONS = gql`
  query($settings: GetAutomationsUserInput) {
    HexomaticAutomation {
      getAutomationsPublic(settings: $settings) {
        automations {
          id
          name
          prices {
            id
            unit_name
            credit_price
            premium_credit_price
          }
          url
          meta_title
          short_description
          long_description
          icon_url
          category {
            id
            name
          }
          type {
            id
            name
          }
          is_new
        }
        error_code
      }
    }
  }
`;

export const LEFT_PACKAGES_COUNT = gql`
  query {
    User {
      getHexomateLeftLTDPackagesCount {
        count
        error
        message
      }
    }
  }
`;

export const PAYMENT_METHOD_QUERY = gql`
  query {
    User {
      creditCardInfo {
        number
        name
        expiry
      }
    }
  }
`;

export const GET_USER_WATCH_SETTINGS_QUERY = gql`
  query {
    UserWatchSettings {
      get {
        pricing_package
      }
    }
  }
`;

export const GET_HEXOMETER_USER_SETTINGS = gql`
  query($user_id: Int!) {
    HexometerUserSettings {
      get(user_id: $user_id) {
        pricing_package
        pricing_package_interval
        pricing_package_count
      }
    }
  }
`;

export const GET_HEXOMATIC_USER = gql`
  query GET_HEXOMATIC_USER {
    HexomaticUser {
      getByLegacyId {
        id
        automation_credit
        premium_automation_credit
        user_legacy_id
        pricing_package
        pricing_package_interval
        pricing_package_count
        stripe_subscription_id

        automation_credit
        premium_automation_credit

        left_premium_automation_credit
        left_automation_credit

        error_code
      }
    }
    User {
      get {
        verified
        email
      }
    }
  }
`;

export const LIST_PRODUCTS = gql`
  query($settings: ListProductsInput) {
    Billing {
      listProducts(settings: $settings) {
        products {
          hexomaticProducts {
            id
            name
            interval
            productId
            priceId
            amount
            max_stack_count
            limits {
              additional_premium_credits_count
              credits_count
            }
            actions {
              scraping_recipe {
                can_create_scraping_recipe
              }
              workflow {
                scheduling
                simultaneous_running_workflow_count
              }
              specify_server_location
            }
            integrations {
              integrately {
                allowed
              }
              pabbly {
                allowed
              }
              syncspider {
                allowed
              }
              zapier {
                allowed
              }
              webhook {
                allowed
              }
              hexomatic_api {
                allowed
              }
            }
            isPopular
          }
        }
        error_code
      }
    }
  }
`;
export const LIST_CUSTOMER_CARD = gql`
  query($settings: ListCustomerCardsInput) {
    Billing {
      listCustomerCards(settings: $settings) {
        cards {
          id
          createdAt
          updatedAt
          cardId
          customerId
          brand
          lastDigits
          isDefault
        }
        error_code
      }
    }
  }
`;
